<!-- Button trigger modal -->

    <!-- Modal -->
    <div class="modal fade" id="editUserModal" tabindex="-1" role="dialog" aria-labelledby="editUserModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="editUserModalLabel">Editar Usuario</h5>
            <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form *ngIf="userData" [formGroup]="editUserForm" (ngSubmit)="editUser()">
        <div class="modal-body">
            <div class="form-group">
                <label for="UserFullName">Nombre Completo</label>
                <input type="text"  class="form-control" id="UserFullName" formControlName="fullname">
            </div>
            <div class="form-group">
                <label for="UserEmail">Email</label>
                <input type="text" class="form-control" id="UserEmail" formControlName="email">
            </div>
            <div class="form-group">
                <label for="UserPhoneNo">Teléfono</label>
                <input type="text"  class="form-control" id="UserPhoneNo" formControlName="telephone" [brmasker]="{mask: '(000) 000-0000', type:'num'}">
            </div>
            <div class="form-group">
                <label for="city">Ciudad</label>
                <input type="text"  class="form-control" id="city" formControlName="city">
            </div> 
            <div class="form-group">
                <label for="active">Status</label>
                <!-- <input type="text" class="form-control" id="role" formControlName="role"> -->
                <select class="form-control" id="active" formControlName="active">
                    <option value="true">Activo</option>
                    <option value="false">Inactivo</option>
                </select>
            </div>    
            <!-- <div class="form-group">
                <label for="role">Rol</label>
                <select class="form-control" id="role" formControlName="idRole">
                    <option value="2">Producer</option>
                    <option value="1">Admin</option>
                </select>
            </div>   -->
        </div>
        <div *ngIf="missingFieldMsg" class="alert alert-danger" role="alert">
            Falta algun campo...
        </div>
        <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
            Error intente luego...
        </div>
        <div class="modal-footer">
            
            <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Guardar</button>
        </div>
        </form>
        </div>
    </div>
    </div>